import {
  BRAND_PRODUCT,
  PROMISE_PENDING,
  PROMISE_FULFILLED,
  PROMISE_REJECTED
} from "../constants";

const initialState = {
  brandProducts: {
    data: [],
    isFetch: false,
    error: null,
    isProductFilter: false,
  },
  collection_variants: {
    data: [],
    isFetch: false,
    error: null,
  },
  isSearchResultPending: false,
  isFiltering: false,
  stillPending: false,
  hasExecute: false,
  caseSorting: 'most_popular',
  modalSearchOpen: false,
  dataRecommended: {
    data: [],
    isFetch: false,
    error: false,
  },
  searchResult: [],
  searchDrawer: [],
  status_code_filter: 0,
  message_filter: "",
  searchResultTmp: [],
  totalFilter: 0,
  concierge: {
    data: [],
    isFetch: false,
    error: null,
  },
  searchKeyword: "",
  redirectSearch: true,
  errorMessageSearch: "",
  productsInStock: [],
  productDetails: {},
  handbagCondition: {},
  productPopulars: {},
  brandsResult: [],
  pagination: null,
  upcomingProduct: {
    data: [],
    error: null,
    isFetch: false,
  },
  isSearchOpen: false,
  productCategories: {
    isFetch: false,
    categories: null,
    error: null,
  },
  recentSearch: {
    data: [],
    isFetching: false,
    error: null,
  },
  saleHistory: {
    data: [],
    isFetching: false,
    error: null,
  },
  trending: {
    data: [],
    isFetching: false,
    error: null,
    pagination: null,
  },
  topSelling: {
    data: [],
    isFetching: false,
    error: null,
    pagination: null,
  },
  collection: {
    isFetching: false,
    error: null,
    id: null,
    slug: null,
    collectionType: "product_variants",
    sort_by: "most_popular",
    products: {
      data: [],
      isFetching: false,
      status_code: null,
      hasMoreData: null,
    },
    imagePortrait: null,
    imageLandscape: null,
    status_code: null,
    all_category_banner: {
      imagePortrait: null,
      imageLandscape: null,
    }
  },
  dataSection: {
    data: {},
    error: null,
  },
  isClickMenu: false,
  productAggregations: {},

  products: {
    data: [],
    isFetch: false,
    isProductFilter: false,
    current_page: null,
    last_page: null,
    next_page: null,
    per_page: null,
    total_hits: null,
    total: null,
    message: "",
    error: null
  }
}

const onError = (err) => {
  return err.response !== null && err.response !== undefined
    ? { ...err.response.data }
    : {
      error: {
        message: "I got something undefined errors",
        status_code: 500,
      },
    };
};

const brandsProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${BRAND_PRODUCT}${PROMISE_PENDING}`: {
      return {
        ...state,
        products: { ...state.products, isFetch: true, isProductFilter: false },
      };
    }
    case `${BRAND_PRODUCT}${PROMISE_FULFILLED}`: {
      const { data = [], status_code, message, current_page } = action.payload;
      const _data = data.current_page > 1 ? [...state.products.data, ...data.data] : data.data;

      return {
        ...state,
        products: {
          ...state.products,
          ...data,
          data: _data,
          status_code,
          message,
          isFetch: false,
          error: null,
          isProductFilter: false,
        },
      };
    }
    case `${BRAND_PRODUCT}${PROMISE_REJECTED}`: {
      return {
        ...state,
        products: {
          ...state.products,
          isFetch: false,
          isProductFilter: false,
          ...onError(action.payload),
        },
      };
    }

    default: return state
  }
};

export default brandsProductReducer;